package ru.villawonka.app.presentation.screens.settings.compose.layout

import androidx.compose.runtime.Composable
import ru.villawonka.app.presentation.screens.settings.compose.SettingsCallbacks
import ru.villawonka.app.presentation.screens.settings.viewmodel.SettingsUIState
import ru.villawonka.app.presentation.sharedviews.DefaultErrorStateLayout
import ru.villawonka.app.presentation.sharedviews.DefaultLoadingStateLayout

@Composable
fun SettingsRootLayout(
    state: SettingsUIState,
    callbacks: SettingsCallbacks
) {
    when (state) {
        is SettingsUIState.Loading -> DefaultLoadingStateLayout()
        is SettingsUIState.Error -> DefaultErrorStateLayout(failure = state.failure, onRetryClick = callbacks.onRetryButtonClick)
        is SettingsUIState.Data -> SettingsDataStateLayout(state, callbacks)
    }
}